<template>
  <div class="padres-container">
    <div class="overlay-rosado" />
    <br><br>

    <!-- Corte de Honor -->
    <div class="bloque-texto">
      <div ref="corteTituloRef" class="texto-container texto-novia">
        <span class="novia">Corte de Honor</span>
      </div>

      <img ref="separador1Ref" src="@/assets/mon1.png" class="separador-final" alt="Separador" />
      <span class="novia1">Quinceañera_</span><br><br>
      <div ref="quinceaneraRef" class="padrino-linea">Victoria Vargas</div><br><br>

      <span class="novia1">Chambelan de Honor:</span><br><br>
      <div ref="chambelanRef" class="padrino-linea">Emyr Sida</div><br><br>

      <span class="novia1">Damas:</span><br>
      <div class="padrinos-lista">
        <div v-for="(dama, i) in damas" :key="'dama' + i" ref="damaRefs" class="padrino-linea"> {{ dama }}</div>
      </div>
<br><br>
      <span class="novia1">Chambelanes:</span>
      <div class="padrinos-lista">
        <div v-for="(ch, i) in chambelanes" :key="'chambelan' + i" ref="chambelanRefs" class="padrino-linea"> {{ ch }}</div>
      </div>
    </div>

    <!-- Separador Bonito -->
    <img ref="separadorSeparadorRef" src="@/assets/mon1.png" class="separador-final" alt="Separador" />

    <!-- Texto Padrinos -->
    <div class="bloque-texto">
      <div ref="padrinoTituloRef" class="texto-container texto-novia">
        <span class="novia">Padrinos</span><br>
      </div>
      <div class="padrinos-lista">
        <div
          v-for="(padrino, i) in padrinos"
          :key="'padrino' + i"
          ref="padrinoRefs"
          class="padrino-linea"
          v-text="padrino"
        ></div>
      </div>
    </div>

    <img ref="separador2Ref" src="@/assets/separador.png" class="separador-final" alt="Separador" />
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const corteTituloRef = ref(null)
    const quinceaneraRef = ref(null)
    const chambelanRef = ref(null)
    const padrinoTituloRef = ref(null)
    const separador1Ref = ref(null)
    const separadorSeparadorRef = ref(null)
    const separador2Ref = ref(null)

    const damaRefs = ref([])
    const chambelanRefs = ref([])
    const padrinoRefs = ref([])

   const damas = [
  'Elizabeth Sanchez',
  'Yaireth Luna',
  'Kamila Vargas',
  'Jaylah Mendoza',
  'Lucia Morales',
  'Jayleen Cortez',
  'Peyton Averi Jones',
  'Melanie Hernandez',
  'Sofia Miliana Alvarez',
  'Ariba Zain',
  'Sophia Sahyun',
  'Ruby Ruiz',
  'Sophia Davis',
  'Olivia Davis'
]

   const chambelanes = [
  'Jayden Johnson',
  'Jesus Lopez',
  'Oscar Garza',
  'Christopher Ayala Peña',
  'Damien Moreno',
  'Cisko Viera',
  'Bryan Hernandez',
  'Valentin Gonzalez',
  'Joaquin Morales',
  'Damian Cazares',
  'Angel Ruiz',
  'Brody Laborin',
  'Ariel Angel Millan',
  'Jaylen Graham'
]
const padrinos = [
  'Jennifer & Gabriel Mendoza',
  'Alexa & Rafael Morales',
  'Lorena & Gustavo Sida',
  'Desiree Vargas & Gabriel Mendoza Jr.',
  'Cristina & John Vargas Jr.',
  'Gabriela & Rodolfo Ruiz',
  'Dee & Freddie Jimenez',
  'Claudia & Roberto Trejo',
  'Janey & Mario Vargas',
  'Mario Vargas'
]
    const animateOnScroll = (el) => {
      if (!el) return
      el.style.opacity = 0
      el.style.transform = 'translateY(15px)'

      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          gsap.to(el, {
            opacity: 1,
            y: 0,
            duration: 0.35,
            ease: 'power2.out',
            delay: 0
          })
          observer.unobserve(el)
        }
      }, { threshold: 0.05, rootMargin: '50px' })

      observer.observe(el)
    }

    onMounted(async () => {
      await nextTick()

      const allElements = [
        corteTituloRef.value,
        separador1Ref.value,
        quinceaneraRef.value,
        chambelanRef.value,
        ...damaRefs.value,
        ...chambelanRefs.value,
        separadorSeparadorRef.value,
        padrinoTituloRef.value,
        ...padrinoRefs.value,
        separador2Ref.value
      ]

      allElements.forEach((el) => {
        animateOnScroll(el)
      })
    })

    return {
      corteTituloRef,
      quinceaneraRef,
      chambelanRef,
      padrinoTituloRef,
      separador1Ref,
      separadorSeparadorRef,
      separador2Ref,
      damaRefs,
      chambelanRefs,
      padrinoRefs,
      damas,
      chambelanes,
      padrinos
    }
  }
}
</script>

<style scoped>
.padres-container {
  position: relative;
  width: 100%;
  display: flex;
  background-color: rgba(0, 0, 0, 0.559);
  flex-direction: column;
  align-items: center;
  padding: 20px 0 0;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}

.overlay-rosado {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bloque-texto {
  margin-bottom: 40px;
  text-align: center;
}

.texto-container {
  z-index: 2;
  padding: 10px;
  max-width: 600px;
  font-family: 'Dancing Script', sans-serif;
  font-size: 18px;
  color: #f6f6f4;
  margin: 0 auto;
}

.novia {
  font-family: 'british', cursive;
  font-size: 26px;
  color: #f6f6f4;
}
.novia1 {
  font-family: 'british', cursive;
  font-size: 22px;
  color: #f6f6f4;
}

.padrinos-lista {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.padrino-linea {
  white-space: pre-line; /* Muestra \n como saltos de línea */
  font-family: "padres", sans-serif;
  font-size: 20px !important;
  color: #f6f6f4;
  opacity: 0;
  transform: translateY(15px);
  margin-bottom: 10px;
  transition: all 0.2s ease;
}

.separador-final {
  width: 30vw;
  height: auto;
  margin: 20px auto;
  display: block;
  opacity: 0;
  transform: translateY(15px);
}

@media (max-width: 600px) {
  .padrino-linea {
    font-size: 16px;
  }
}
</style>